import { render, staticRenderFns } from "./MenuBuilder.vue?vue&type=template&id=39d7abf4&"
import script from "./MenuBuilder.vue?vue&type=script&lang=js&"
export * from "./MenuBuilder.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports